export const NEGATIVE_MEDIA_IGNORING_PROPERTY_MESSAGES = {
  SUCCESS: 'The negative media ignoring properties were successfully saved',
};


// WEBPACK FOOTER //
// ./src/features/monitoring-queue-entry/constants/createNegativeMediaIgnotingPropertyMessages.js